import axiosInstance, { CustomAxiosRequestConfig } from "../services/axios";
import { IInvestment } from "../types/investment";
import { Endpoints } from "./endpoint";
import { QueryObject } from "./global";


export const createInvestmentsApi=async(payload:Partial<IInvestment>)=>{
    const res = await axiosInstance.post(
        `${process.env.NEXT_PUBLIC_API}${Endpoints.INVESMENTS.CREATE}`,
        payload,
        {
            requiresAuth: true // Custom property to skip auth
        } as CustomAxiosRequestConfig
    );
    return res.data;
}
export const updateInvestmentsApi=async(id:string,payload:Partial<IInvestment>)=>{
  const res = await axiosInstance.put(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.INVESMENTS.CREATE}/${id}`,
      payload,
      {
          requiresAuth: true // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}


export const getInvestmentApi=async(id:string)=>{
  const res = await axiosInstance.get(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.INVESMENTS.CREATE}/${id}`,
      {
          requiresAuth: false // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}

export const removeInvestmentApi=async(id:string)=>{
  const res = await axiosInstance.delete(
      `${process.env.NEXT_PUBLIC_API}${Endpoints.INVESMENTS.CREATE}/${id}`,
      {
          requiresAuth: false // Custom property to skip auth
      } as CustomAxiosRequestConfig
  );
  return res.data;
}



export const getInvestmentsApi=async(payload:Partial<QueryObject<{propertyName:string,location:string,investmentStatus:string,sort:string}>>)=>{
    

    let url = `${process.env.NEXT_PUBLIC_API}${Endpoints.INVESMENTS.CREATE}`;
    const queryParams = [];
  
    if (payload.page !== undefined) {
      queryParams.push(`page=${payload.page}`);
    }
    if(payload.location !== undefined && payload.location !==""){
         queryParams.push(`location=${payload.location}`); 
       } 
    if(payload.propertyName!==undefined){
      queryParams.push(`propertyName=${payload.propertyName}`);
    }
      if(payload.investmentStatus !== undefined && payload.investmentStatus !==""){
      queryParams.push(`investmentStatus=${payload.investmentStatus.toUpperCase()}`); 
    } 
     if(payload.sort !== undefined && payload.sort !==""){
      queryParams.push(`sort=${payload.sort}`);  
    }
    if (payload.limit !== undefined) {
      queryParams.push(`limit=${payload.limit}`);
    }
    if(payload.propertyType!==undefined&&payload.propertyType!==""){
          queryParams.push(`propertyType=${payload.propertyType}`);
        }
  //  queryParams.push(`populate=floorplan,documents,property,property.media,property.documents`);
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
  
    const res = await axiosInstance.get(url);
    return res.data;
}